import { clevertapEvent } from 'utils/clevertap';
import { ChartTimeFrames } from '../constants.types';

export const clevertapOnChangeTimeframe = (
  symbol: string,
  timeframe: ChartTimeFrames,
) => {
  clevertapEvent('company_action', {
    Action: 'change_timeframe',
    Stock: symbol,
    Date: timeframe,
  });
};

export const clevertapOnClickChart = (symbol: string) => {
  clevertapEvent('company_action', {
    Action: 'chartbit',
    Stock: symbol,
    Source: 'Chart',
  });
};
